import { fallbackLang } from '../constants';

export function resolveLanguage(preferenceValue: string | null, supportedLanguages: readonly string[]) {
  if (preferenceValue && supportedLanguages.includes(preferenceValue)) {
    // Use Value From Preference
    return preferenceValue;
  }
  return fallbackLang;
}
